module.exports = "https://redage.akamaized.net/src/views/games/other/images/roles/unknown.png";